if ('NodeList' in window && !NodeList.prototype.forEach) {
    console.info('polyfill for IE11');
    NodeList.prototype.forEach = function (callback, thisArg) {
        thisArg = thisArg || window;
        for (let i = 0; i < this.length; i++) {
            callback.call(thisArg, this[i], i, this);
        }
    };
}

(function(){
    // Remove empty <p> tags created by tinymce
    const paragraph = document.querySelectorAll('p') || [];
	paragraph.forEach( e => (e.innerHTML.trim() === '') && e.parentNode.removeChild(e));


    $('.sym-slides').slick({
        accessibility: false
    });
    $('.gallery_slider').slick({
        accessibility: true,
        variableWidth:true
    })

    // TRACKING VALUES
        // Footer Virtual tour link
        let link = document.querySelector('.secondary-navigation__item.secondary-nav-3 a');

        if (link) {
            link.setAttribute('data-custom_click_track_value', 'Footer |Activity Link Click|external|event464');
        } else {
            console.warn('No <a> tag found within the specified selector.');
        }



        function addCustomClickTrackValue(element, message) {
            if (element) {
                element.setAttribute('data-custom_click_track_value', message);
                element.classList.add("custom_click_track");
                console.log(`Data attribute added successfully! Value: ${message}`);
            } else {
                console.warn('The provided element does not exist.');
            }
        }

        if( document.querySelector(".social-media a.facebook")){
            addCustomClickTrackValue(document.querySelector(".social-media a.facebook"), "Footer |Social Site Click |external|event465")
        }

        if( document.querySelector(".social-media a.twitter")){
            addCustomClickTrackValue(document.querySelector(".social-media a.twitter"), "Footer |Social Site Click |external|event465")
        }

        if( document.querySelector(".social-media a.instagram ")){
            addCustomClickTrackValue(document.querySelector(".social-media a.instagram"), "Footer |Social Site Click |external|event465")
        }

    // END TRACKING VALUES

})();